/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

export class TsExpertConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,
      isSendingAnalyzerDNConfigDimmerActive: false,
      // ------- Protocol -------
      isRetriesProblemChecked: false,
      isDiagnosticProblemChecked: false,
      isFaultChecked: false,
      isErrorFrameChecked: false,
      isMissingProblemChecked: false,
      // ------- Analyzer DN -------
      isAttentionSignalChecked: false,
      isCapacitiveEffectChecked: false,
      isBadSignalProblemChecked: false,
      isNoiseProblemChecked: false,
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      // ------- Protocol -------
      isRetriesProblemChecked: resolvedPromisses[0].isRetriesProblemChecked,
      isDiagnosticProblemChecked: resolvedPromisses[0].isDiagnosticProblemChecked,
      isFaultChecked: resolvedPromisses[0].isFaultChecked,
      // isFaultSequenceProblemChecked: resolvedPromisses[0].isFaultSequenceProblemChecked,
      isErrorFrameChecked: resolvedPromisses[0].isErrorFrameChecked,
      isMissingProblemChecked: resolvedPromisses[0].isMissingProblemChecked,
      // ------- Analyzer DN -------
      isAttentionSignalChecked: resolvedPromisses[0].isAttentionSignalChecked,
      isBadSignalProblemChecked: resolvedPromisses[0].isBadSignalProblemChecked,
      isCapacitiveEffectChecked: resolvedPromisses[0].isCapacitiveEffectChecked,
      isNoiseProblemChecked: resolvedPromisses[0].isNoiseProblemChecked,
    });
  }

  // ------ Toggle Protocol Checkboxes ---------
  toggleRetriesProblemCheckbox = () => {
    this.setState({ isRetriesProblemChecked: !this.state.isRetriesProblemChecked });
  }

  toggleDiagnosticProblemCheckbox = () => {
    this.setState({ isDiagnosticProblemChecked: !this.state.isDiagnosticProblemChecked });
  }

  toggleFaultProblemCheckbox = () => {
    this.setState({ isFaultChecked: !this.state.isFaultChecked });
  }

  toggleErrorFrameCheckbox = () => {
    this.setState({ isErrorFrameChecked: !this.state.isErrorFrameChecked });
  }

  toggleMissingProblemCheckbox = () => {
    this.setState({ isMissingProblemChecked: !this.state.isMissingProblemChecked });
  }

  // ------ Toggle Analyzer DN Checkboxes ---------
  toggleIsAttentionSignalProblemCheckbox = () => {
    this.setState({ isAttentionSignalChecked: !this.state.isAttentionSignalChecked });
  }

  toggleIsBadSignalProblemCheckbox = () => {
    this.setState({ isBadSignalProblemChecked: !this.state.isBadSignalProblemChecked });
  }

  toggleIsCapacitiveEffectCheckedProblemCheckbox = () => {
    this.setState({ isCapacitiveEffectChecked: !this.state.isCapacitiveEffectChecked });
  }

  toggleIsNoiseProblemCheckedProblemCheckbox = () => {
    this.setState({ isNoiseProblemChecked: !this.state.isNoiseProblemChecked });
  }

  // Save the TS Expert Configuration
  saveTsExpertConfiguration = () => {
    this.showSendingConfigDimmer();

    let data = {
      isRetriesProblemChecked: this.state.isRetriesProblemChecked,
      isDiagnosticProblemChecked: this.state.isDiagnosticProblemChecked,
      isFaultChecked: this.state.isFaultChecked,
      isErrorFrameChecked: this.state.isErrorFrameChecked,
      isMissingProblemChecked: this.state.isMissingProblemChecked,
    };

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertConfigProtocol_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.REASON + error);
      })
      .finally(this.hideSendingConfigDimmer);
  }

  // Save the TS Expert Configuration
  saveAnalyzerDnTsExpertConfiguration = () => {
    this.showSendingAnalyzerDNConfigDimmer();

    let data = {
      // Meio Fisico
      isAttentionSignalChecked: this.state.isAttentionSignalChecked,
      isBadSignalProblemChecked: this.state.isBadSignalProblemChecked,
      isCapacitiveEffectChecked: this.state.isCapacitiveEffectChecked,
      isNoiseProblemChecked: this.state.isNoiseProblemChecked,
    };

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertConfigFisic_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.REASON + error);
      })
      .finally(this.hideSendingAnalyzerDNConfigDimmer);
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });

  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  showSendingAnalyzerDNConfigDimmer = () => this.setState({ isSendingAnalyzerDNConfigDimmerActive: true });

  hideSendingAnalyzerDNConfigDimmer = () => this.setState({ isSendingAnalyzerDNConfigDimmerActive: false });

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Grid columns={2} doubling textAlign="left">
        <Grid.Column>
          <Segment>
            <Header as='h2' textAlign="center" color="teal">
              {Strings.TS_EXPERT_PROT}
            </Header>
            <Divider clearing />

            <Segment id="problems-list" style={listSegmentStyle} basic>

              <List divided verticalAlign='middle'>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_RETRIES_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_RETRIES_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleRetriesProblemCheckbox}
                          checked={this.state.isRetriesProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_DIAGNOSTIC_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_DIAGNOSTIC_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleDiagnosticProblemCheckbox}
                          checked={this.state.isDiagnosticProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_FAULT_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_FAULT_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleFaultProblemCheckbox}
                          checked={this.state.isFaultChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_ERROR_FRAME_LIST_HEADER}</List.Header>
                        {Strings.ERROR_FRAME_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleErrorFrameCheckbox}
                          checked={this.state.isErrorFrameChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_MISSING_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_MISSING_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleMissingProblemCheckbox}
                          checked={this.state.isMissingProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
              </List.Item>
              </List>

            </Segment>

            <Button
              fluid
              color="teal"
              content={Strings.SAVE}
              onClick={this.saveTsExpertConfiguration} />

            <Dimmer active={this.state.isSendingConfigDimmerActive} >
              <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
            </Dimmer>

          </Segment>
        </Grid.Column>

        <Grid.Column>
          <Segment>
            <Header as='h2' textAlign="center" color="teal">
              {Strings.TS_EXPERT_DP}
            </Header>
            <Divider clearing />

            <Segment id="problems-list" style={listSegmentStyle} basic>

              <List divided verticalAlign='middle'>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.ATTENTION_SIGNAL}</List.Header>
                        {Strings.ATTENTION_SIGNAL_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsAttentionSignalProblemCheckbox}
                          checked={this.state.isAttentionSignalChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.BAD_SIGNAL}</List.Header>
                        {Strings.BAD_SIGNAL_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsBadSignalProblemCheckbox}
                          checked={this.state.isBadSignalProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CAPACITIVE_EFFECT}</List.Header>
                        {Strings.CAPACITIVE_EFFECT_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsCapacitiveEffectCheckedProblemCheckbox}
                          checked={this.state.isCapacitiveEffectChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.NOISE}</List.Header>
                        {Strings.NOISE_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsNoiseProblemCheckedProblemCheckbox}
                          checked={this.state.isNoiseProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Content>
                </List.Item>

              </List>

            </Segment>

            <Button
              fluid
              color="teal"
              content={Strings.SAVE}
              onClick={this.saveAnalyzerDnTsExpertConfiguration} />

            <Dimmer active={this.state.isSendingAnalyzerDNConfigDimmerActive} >
              <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
            </Dimmer>

          </Segment>
        </Grid.Column>


      </Grid >
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "56vh"
};

export default TsExpertConfig;
